import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular/lazy';
import { StorageService } from './storage-service.service';
import { ModaleConsensoPrivacyPage } from '../components/modali/modale-consenso-privacy/modale-consenso-privacy.page';

export type SocialChannel = 'google' | 'facebook' | 'apple';

interface PrivacyConsentRecord {
  accepted: boolean;
  date: string;
  channel: SocialChannel;
}

@Injectable({ providedIn: 'root' })
export class PrivacyConsentService {

  private static readonly STORAGE_KEY = 'privacyConsentSocial';

  constructor(
    private modalCtrl: ModalController,
    private storage: StorageService
  ) { }

  async hasValidConsent(): Promise<boolean> {
    const record: PrivacyConsentRecord | null = await this.storage.get(PrivacyConsentService.STORAGE_KEY);
    return record?.accepted === true;
  }

  async ensureConsent(channel: SocialChannel): Promise<boolean> {
    if (await this.hasValidConsent()) return true;

    const modal = await this.modalCtrl.create({
      component: ModaleConsensoPrivacyPage,
      backdropDismiss: false,
      cssClass: 'modale-consenso-privacy'
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();

    if (data?.accepted === true) {
      await this.saveConsent(channel);
      return true;
    }
    return false;
  }

  private async saveConsent(channel: SocialChannel): Promise<void> {
    const record: PrivacyConsentRecord = {
      accepted: true,
      date: new Date().toISOString(),
      channel
    };
    await this.storage.set(PrivacyConsentService.STORAGE_KEY, record);
  }
}
